import request from 'apps/new-web/lib/request';
import I18n from 'apps/new-web/views/components/i18n';
import { SubmissionError } from 'redux-form';

const errors = {
  CODE_INVALID: I18n.translate('Reset link is no longer valid. Please request a new one.'),
  CONFIRM_EMPTY: I18n.translate('Please enter a confirm password.'),
  CONFIRM_INVALID: I18n.translate('Password and confirm do not match.'),
  PASSWORD_EMPTY: I18n.translate('Please enter a password.'),
  PASSWORD_MIN_LENGTH: I18n.translate('Password requires at least 8 characters.'),
  SERVER_ERROR: I18n.translate('There was a problem trying to reset your password.')
};

function sendResetPassword({ password }, code) {
  return request.post('/users/reset-password')
    .send({ code, password })
    .end()
    .then(req => req.body)
    .catch((err) => {
      if (err.status === 400 && err.response && err.response.body) {
        const { invalidCode, invalidPassword, message } = err.response.body;
        if (invalidPassword) throw new SubmissionError({ password: message });
        if (invalidCode) throw new SubmissionError({ _error: errors.CODE_INVALID });
      }

      throw new SubmissionError({ _error: errors.SERVER_ERROR });
    });
}

function validateConfirm({ confirm, password }) {
  if (!confirm) return errors.CONFIRM_EMPTY;
  if (password !== confirm) return errors.CONFIRM_INVALID;
}

function validatePassword({ password }) {
  if (!password) return errors.PASSWORD_EMPTY;
  if (password.length < 8) return errors.PASSWORD_MIN_LENGTH;
}

function validate(values) {
  return {
    confirm: validateConfirm(values),
    password: validatePassword(values)
  };
}

module.exports = {
  sendResetPassword,
  validate
};
